export default {
    ADD_ITEM(state, item) {
        state.list.unshift(item)
    },
    VIEW_MODEL(state, item) {
        state.children = [];
        state.model = item;
    },
    GET_CHILDREN(state, items) {
        state.children = items;
    },
    SET_LIST(state, list) {
        state.list = list.rows
        state.total = list.total
        state.page = list.page
    },
    UPDATE_ADDRESS(state, record) {
        const productIndex = state.list.findIndex((p) => p.id == record.id)
        Object.assign(state.list[productIndex], record)
    },
    REMOVE_ITEM(state, itemId) {
        const ItemIndex = state.list.findIndex((p) => p.id == itemId)
        state.list.splice(ItemIndex, 1)
    },
}
